import { StorageOptionFull } from 'owa-storage-option';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import * as React from 'react';
import { getUserConfiguration } from 'owa-session-store';
// This will be removed after PremiumDashboardApril is rolled out.
var StorageOption = {
    key: 'StoragePremium',
    titleStringKey: 'optionTitle_storage',
    searchTermsStringKey: 'optionTitle_storage',
    fullOptionFormSettings: {
        render: function () { return React.createElement(StorageOptionFull, { isPremium: true }); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () {
        return isControlFeatureEnabled('auth-PremiumDashboardApril') ||
            !isControlFeatureEnabled('auth-PremiumDashboard') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox;
    },
};
var StorageOptionApril = {
    key: 'StoragePremium_',
    titleStringKey: 'optionTitle_storage',
    searchTermsStringKey: 'optionTitle_storage',
    fullOptionFormSettings: {
        render: function () { return React.createElement(StorageOptionFull, { isPremium: true }); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () {
        return !isControlFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox;
    },
};
export default StorageOption;
export { StorageOptionApril };
//# sourceMappingURL=PremiumStorageOption.js.map